import { Component } from 'react'
import { Tabs } from 'components/ideal-core-ui'
import queryString from 'query-string'
import { ProfileContainer } from './Profile'
import { Organization } from './Organization'
import { PersonalSettings } from './PersonalSettings'
import { isAdmin } from 'utils/authService'
import { withRouter } from 'hocs'
import { SentEmails } from './SentEmails'
import { HelpCenterContent } from 'components/common/modals/HelpCenterModal/HelpCenterContent'

@withRouter
class Admin extends Component {
  render() {
    const { tab } = queryString.parse(this.props.router.location.search)
    return (
      <Tabs
        withUpdateUrl
        activeTabKey={tab || 'details'}
        tabs={[
          {
            key: 'profile',
            label: 'Profile',
            value: <ProfileContainer />
          },
          {
            key: 'personalSettings',
            label: 'Personal Settings',
            value: <PersonalSettings />
          },
          {
            key: 'organization',
            label: 'Organization',
            value: <Organization />,
            disabled: !isAdmin()
          },
          {
            key: 'emails',
            label: 'Sent Emails',
            value: <SentEmails />
          },
          {
            key: 'help',
            label: 'Help',
            value: <HelpCenterContent />
          }
        ]}
      />
    )
  }
}

export default Admin
